import React from 'react';
import wb0 from '../img/Detail/promotional-design-detail.jpg';
import './Detail.css';
const BibimcosDetail = () => {
  return (
    <div className="image-detail-container">
      <img src={wb0} alt="Kuş" />
    </div>
    
  );
};

export default BibimcosDetail;